// DS: i1.10
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Tier: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M14.8341 5.50142L13.3469 12.9179C13.2907 13.1982 13.0445 13.4 12.7586 13.4H3.24188C2.95599 13.4 2.7098 13.1982 2.65359 12.9179L1.16643 5.50142C1.10005 5.17036 1.44838 4.91106 1.74647 5.06963L5.37525 6.99993L7.63807 2.17261C7.78196 1.86564 8.21854 1.86564 8.36243 2.17261L10.6252 6.99993L14.254 5.06963C14.5521 4.91106 14.9005 5.17036 14.8341 5.50142Z" />
    </svg>
  </IconWrap>
);
Tier.displayName = 'Tier';

export default Tier;
